var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { FontWeights, mergeStyles, Text as FluentText } from "@fluentui/react";
function getPropsOf(type) {
    switch (type) {
        case 'h1': {
            return {
                variant: 'xLargePlus',
                styles: {
                    fontWeight: FontWeights.semibold,
                    paddingBottom: "12px",
                },
            };
        }
        case 'h2': {
            return {
                variant: 'large',
                styles: {
                    fontWeight: FontWeights.regular,
                    paddingBottom: "8px",
                }
            };
        }
        case 'h3': {
            return {
                variant: 'mediumPlus',
                styles: {
                    fontWeight: FontWeights.semibold,
                    paddingBottom: "8px",
                    color: "#6E6E6E",
                }
            };
        }
        case 'caption': {
            return {
                variant: 'medium',
                styles: {
                    paddingBottom: "8px",
                }
            };
        }
        default:
            return {
                styles: {
                    paddingBottom: "8px",
                },
            };
    }
}
export var Text = function (props) {
    var textProps = getPropsOf(props.type);
    var className = props.className, rest = __rest(props, ["className"]);
    return (_jsx(FluentText, __assign({ className: mergeStyles({ color: "inherit" }, textProps.styles, className), variant: textProps.variant }, rest, { children: props.children }), void 0));
};
//# sourceMappingURL=Text.js.map